module.exports = __webpack_public_path__ + "img/fbbee35.jpg";